var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsReadingListWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "auto_stories_black_18dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27949",
    "data-name": "Group 27949"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7916",
    "data-name": "Rectangle 7916",
    width: 28,
    height: 28,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27950",
    "data-name": "Group 27950",
    transform: "translate(1.131 0.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16665",
    "data-name": "Path 16665",
    d: "M26.117,6a12.367,12.367,0,0,0-1.72-.714V19.358a12.036,12.036,0,0,0-4.095-.725,12.4,12.4,0,0,0-6.434,1.848V6.326A12.784,12.784,0,0,0,1.62,6,1.138,1.138,0,0,0,1,7.028V21.16a1.156,1.156,0,0,0,1.17,1.158,1.246,1.246,0,0,0,.562-.14,10.17,10.17,0,0,1,4.7-1.2,10.581,10.581,0,0,1,6.434,2.34,10.581,10.581,0,0,1,6.434-2.34,10.039,10.039,0,0,1,4.7,1.217,1.246,1.246,0,0,0,.562.14,1.163,1.163,0,0,0,1.17-1.158V7.028A1.138,1.138,0,0,0,26.117,6ZM11.529,19.358a11.92,11.92,0,0,0-8.189,0V7.765a10.44,10.44,0,0,1,8.189.012ZM22.058.5,16.208,6.349V17.463L22.058,12.2Z",
    transform: "translate(-1 -0.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsReadingListWhiteIcon);
export default __webpack_public_path__ + "static/media/gs-readingList-whiteIcon.0f59969eca3b2475b8c2594557a78d74.svg";
export { ForwardRef as ReactComponent };